import { createRef, ReactElement, RefObject, useRef, useState } from 'react';
import { Message } from '@messageformat/react';
import { Button } from '@op/opds.opux';
import { IconAdd } from '@op/opds.opux-icons/action';
import { space } from '@op/opds.tokens';
import ProductInput from './ProductInput';
import ProductSummaryTile from './ProductSummaryTile';

const InvestmentProduct = (): ReactElement => {
  const addButtonRef: RefObject<HTMLButtonElement> = useRef(null);
  const [products, setProducts] = useState([
    { buyPrice: 0, sellPrice: 0, ref: createRef<HTMLParagraphElement>() },
  ]);

  const addNewProduct = (): void => {
    setProducts([
      ...products,
      { buyPrice: 0, sellPrice: 0, ref: createRef<HTMLParagraphElement>() },
    ]);
  };

  const calculateSum = (field: 'buyPrice' | 'sellPrice'): number => {
    return products.reduce((acc, current) => acc + current[field], 0);
  };

  const buySum = calculateSum('buyPrice');
  const sellSum = calculateSum('sellPrice');

  const handleDelete = (indexToDelete: number): void => {
    const updatedProducts = products.filter((_, index) => index !== indexToDelete);
    if (indexToDelete >= products.length - 1) {
      addButtonRef.current?.focus();
    } else {
      // move focus to the next product's title
      updatedProducts[indexToDelete]?.ref.current?.focus();
    }
    setProducts(updatedProducts);
  };

  const handlePriceChange = (
    index: number,
    buyPrice: number,
    sellPrice: number,
  ): void => {
    const updatedProducts = products.map((product, idx) =>
      idx === index ? { buyPrice, sellPrice, ref: product.ref } : product,
    );
    setProducts(updatedProducts);
  };

  return (
    <>
      {products.map((element, index) => {
        const productNo = index + 1;
        return (
          <ProductInput
            key={`productInput ${productNo}`}
            index={index}
            buyPrice={element.buyPrice}
            sellPrice={element.sellPrice}
            onChange={handlePriceChange}
            onDelete={handleDelete}
            titleRef={element.ref}
          />
        );
      })}
      <div
        className="investoracademy-vertical-flex-align"
        style={{ marginBottom: space.large }}
      >
        <Button
          ref={addButtonRef}
          icon={IconAdd}
          onClick={addNewProduct}
          style={{
            width: 'auto',
          }}
        >
          <Message id="course9.task1.add_product" />
        </Button>
      </div>
      <ProductSummaryTile buySum={buySum} sellSum={sellSum} />
    </>
  );
};

export default InvestmentProduct;
